<div class="container relative">
  <div class="flex align-items-center header">
    <div *ngFor="let header of headers; let i = index" [style.width.%]="this.widthColumns[i]">
      <ng-container *ngTemplateOutlet="header"> </ng-container>
    </div>
  </div>
  
  <div class="row">
    <div class="flex linha" *ngFor="let row of data; let position = index">
      <div *ngFor="let column of columns; let i = index" [style.width.%]="this.widthColumns[i]">
        <ng-container *ngTemplateOutlet="column; context: { row, position }"></ng-container>
      </div>
    </div>
    <div *ngFor="let row of rows">
      <ng-container *ngTemplateOutlet="row; context: { data }"> </ng-container>
    </div>
  </div>
  <div class="loading" *ngIf="loading">
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
  </div>
</div>

